<script>
import {AuthTestDataProvider} from "../../sevices/AuthTestDataProvider";

export default {
    name: "TestResult",
    props: ['attemptId', 'dataProvider'],
    data() {
        return {
            loading: true,
            result: null,
        }
    },
    created() {
        let data = {
            attemptId: this.attemptId,
        }

        this.dataProvider.getTestResult(data).then((response) => {
            if (response.data.ok) {
                this.result = response.data.result;
                this.loading = false;
            }
        })

        if (this.dataProvider instanceof AuthTestDataProvider) {
            this.setBreadcrumb();
        }
    },
    methods: {
        setBreadcrumb() {
            let result = [{
                text: this.$t('index'),
                to: {name: 'base'}
            }];
            result.push({
                text: 'Результаты теста'
            });
            this.$store.commit('setBreadcrumb', result);
        },
    }
}
</script>

<template>
    <v-container fluid v-if="this.loading === false">
        <v-card>
            <v-card-text>
                <div class="text-center">
                    <v-row>
                        <v-col cols="12">
                            <h3>Результаты теста</h3>
                            <h2>{{this.result.test.title}}</h2>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <div>
                                <div v-if="result.passed">
                                    <v-icon
                                        color="green"
                                        x-large
                                    >mdi-check-circle-outline</v-icon>
                                </div>
                                <div v-else>
                                    <v-icon
                                        color="error"
                                        x-large
                                    >mdi-alert-octagon-outline</v-icon>
                                </div>
                                <div v-if="result.passed">
                                    <h1>Тест пройден</h1>
                                </div>
                                <div v-else>
                                    <h1>Тест провален</h1>
                                </div>
                                <div>
                                    Затраченное время: {{ this.result.time }}
                                </div>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <div>
                                Вы набрали баллов <strong>{{ this.result.userScore }} из {{ this.result.maxScore }}</strong> возможных.
                            </div>
                            <div>
                                Вы правильно ответили на <strong>{{ this.result.rightAnswers }} из {{ this.result.totalQuestions }}</strong> вопросов.
                            </div>
                            <div>
                                Вы набрали <strong>{{ this.result.userPercentage }}%</strong> правильных ответов при <strong>{{ this.result.minPercentage }}%</strong>, необходимых для прохождения теста.
                            </div>
                            <div v-if="result.passed">
                                Вы набрали необходимое количество баллов и ответили на все обязательные вопросы.
                            </div>
                            <div v-else-if="result.minPercentage > this.result.userPercentage">
                                Вы не набрали необходимое минимальное количество баллов.
                            </div>
                            <div v-else>
                                Вы не ответили правильно на все обязательные вопросы.
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
    <v-container v-else>
        <v-row>
            <v-col>
                <v-progress-linear indeterminate></v-progress-linear>
            </v-col>
        </v-row>
    </v-container>
</template>

<style scoped>

</style>
